import Project from 'src/entities/project';
import useSnackbarSystem from '@ui/systems/useSnackbarSystem';
import useUpdateProjectPermissionsMutation from '@projects/queries/useUpdateProjectPermissionsMutation';
import { trackDownloadPermissionsChanged } from 'src/services/tracker/trackers/projects';
import { useCallback, useState } from 'react';

const useDownloadsEnabledForReviewers = ( { project }: { project: Project } ) => {
	const snackbarSystem = useSnackbarSystem();
	const [ downloadsEnabledForReviewers, setDownloadsEnabledForReviewers ] = useState(
		project.downloadsEnabledForReviewers
	);
	const { mutate: updateProjectPermissions } = useUpdateProjectPermissionsMutation( { projectID: project.id } );

	const updateDownloadsEnabledForReviewers = useCallback( ( downloadsEnabled: boolean ) => (
		updateProjectPermissions(
			{ downloads_enabled_for_reviewers: downloadsEnabled },
			{
				onSuccess: ( _, { downloads_enabled_for_reviewers } ) => {
					trackDownloadPermissionsChanged( {
						projectID: project.id,
						reviewerDownloadsEnabled: downloads_enabled_for_reviewers
					} );

					snackbarSystem.showSuccessMessage( {
						title: downloads_enabled_for_reviewers
							? 'Downloads are enabled for all reviewers'
							: 'Downloads are disabled for all reviewers'
					} );
				}
			}
		)
	), [ updateProjectPermissions, snackbarSystem, project.id ] );

	const onEnabledForReviewersChange = useCallback( () => {
		const enabledForReviewers = !downloadsEnabledForReviewers;
		setDownloadsEnabledForReviewers( enabledForReviewers );
		updateDownloadsEnabledForReviewers( enabledForReviewers );
	}, [ downloadsEnabledForReviewers, updateDownloadsEnabledForReviewers ] );

	return {
		downloadsEnabledForReviewers,
		onEnabledForReviewersChange
	};
};

export default useDownloadsEnabledForReviewers;
